import React, { Component } from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { Utils } from '../../utils/utils';
import './card.css';

export default class Card extends Component {
  constructor(props) {
    super(props);

    this.state = {
      "color": "#FFF"
    }
  }

  componentWillMount() {
    this.setColor()
  }

  setColor() {
    this.setState({
      "backgroundColor": Utils.getCustomizationConfig("common", "tertiary_color")
    })
  }

  getStyle() {
    var style = {};
    var backgroundColor = this.state.backgroundColor;
    style.backgroundColor = backgroundColor || "#084c8a";

    return style;
  }

  render() {
    return (
      <div data-id={this.props.uid} className={`rdp-react-template-component-card ${this.props.customClassName || ""} ${((this.props.downloaded || 0) > 0) ? "downloaded" : ""}`} onClick={() => this.props.onClick && this.props.onClick()}>
        <div className="rdp-react-template-component-card-cover" style={{backgroundImage: `url(${this.props.thumb})`}}>
          {this.props.type === "palestra" &&
            <span className="rdp-react-template-component-card-icon-palestra" style={this.getStyle()}></span>  
          }
          {this.props.type === "video" &&
            <span className="rdp-react-template-component-card-icon-video" style={this.getStyle()}></span>  
          }
          {this.props.type === "evento" &&
            <span className="rdp-react-template-component-card-icon-evento" style={this.getStyle()}></span>  
          }
          {this.props.type === "course" &&
            <span className="rdp-react-template-component-card-icon-course" style={this.getStyle()}></span>  
          }
          {this.props.type === "blog" &&
            <span className="rdp-react-template-component-card-icon-blog" style={this.getStyle()}></span>  
          }
          
        </div>
        <div className="rdp-react-template-component-card-info">
          <div>
            <span className="rdp-react-template-component-card-date">{this.props.date}</span>
            {/* <h2 className="rdp-react-template-component-card-title" dangerouslySetInnerHTML={{__html: this.props.title}}></h2> */}
            <span className="rdp-react-template-component-card-localization">{this.props.localization}</span>
          </div>
          {(this.props.activitiesLabel || this.props.progress) &&
            <div className="rdp-react-template-component-card-activities">
              {this.props.activitiesLabel &&
                <span className="rdp-react-template-component-card-activities-label">
                  Atividades: {this.props.activitiesLabel}
                </span>
              }
              {this.props.progress > 0 &&
                <div className="rdp-react-template-component-card-progress">
                  <div style={{ width: 20, height: 20 }}>
                    <CircularProgressbar
                      value={this.props.progress}
                      strokeWidth={14}
                      styles={{
                        path: {
                          stroke: "#084c8a",
                          strokeLinecap: 'butt',
                        },
                        trail: {
                          stroke: '#414245',
                          strokeLinecap: 'butt',
                        }
                      }}
                    />
                  </div>
                  <span className="rdp-react-template-component-card-progress-label">{this.props.progress}%</span>
                </div>
              }
            </div>
          }
          
        </div>
      </div>
    );
  }
}
